import { render } from "./About.vue?vue&type=template&id=0643b2d2&scoped=true"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"

import "./About.vue?vue&type=style&index=0&id=0643b2d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0643b2d2"

export default script